/* eslint-disable no-underscore-dangle */
/* eslint-disable no-undef */

/**
 * Decorates a modal dialog with fullscreen capabilities.
 *
 * The decorator applies styles and event listeners to handle fullscreen presentation of a modal dialog. Pushstate
 * makes the browser back button close the dialog.
 *
 * @param {Class} Sup The modal dialog class to decorate. Must be (subclass) of type ModalOverlay.
 */
const FullscreenDecorator = Sup =>
    class extends Sup {
        constructor(...props) {
            super(...props);

            // Bind this since it does not override super method
            this._handlePopstate = this._handlePopstate.bind(this);
        }

        show() {
            super.show();
            this._applyTempStyle();
            this._addEventListeners();

            // Push two states onto the stack to prevent the back button from performing a page load
            window.history.replaceState(null, '');
            window.history.pushState(null, '');
        }

        hide() {
            super.hide();
            this._removeTempStyle();
            this._removeEventListeners();

            // Pop the fullscreen state
            window.history.go(-1);
        }

        _applyTempStyle() {
            document.documentElement.classList.add('modal--document-body');
        }

        _removeTempStyle() {
            document.documentElement.classList.remove('modal--document-body');
            document.body.classList.remove('modal--document-body');
        }

        _addEventListeners() {
            window.addEventListener('keydown', this._handleKeydown, true);
            window.addEventListener('popstate', this._handlePopstate);
        }

        _removeEventListeners() {
            window.removeEventListener('keydown', this._handleKeydown, true);
            window.removeEventListener('popstate', this._handlePopstate);
        }

        _handleKeydown(evt) {
            if (evt.keyCode === 27 /* Escape */) {
                this.hide();
                evt.stopPropagation();
            }
        }

        _handlePopstate() {
            // Re-push fullscreen state, will be popped again later
            window.history.pushState(null, '');

            this.hide();
        }
    };

export default FullscreenDecorator;
